var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ZaNotFound",class:_vm.elmClasses},[_c('div',{staticClass:"ZaNotFound__inner"},[_c('ZaPageHeader',{attrs:{"title":'Die Seite wurde leider nicht gefunden.<br/><br/>'}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }